import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {DueDiligenceService} from "./due-diligence.service";
import {FormControl} from "@angular/forms";
import {debounceTime, distinctUntilChanged, Subscription} from "rxjs";


enum DueDiligenceView {ALL, USER}
@Component({
  selector: 'app-due-diligence',
  templateUrl: './due-diligence.component.html',
  styleUrls: ['./due-diligence.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone:false
})
export class DueDiligenceComponent implements OnInit{

  public view: DueDiligenceView = DueDiligenceView.USER

  public filterControl:FormControl = new FormControl()
  public sortCategoryControl: FormControl = new FormControl()
  public filterSubscription: Subscription;

  public sortCategories = ['Screening Date', 'Closing Date', 'Project Name']
  constructor(public ddService: DueDiligenceService) {
    this.filterSubscription = this.filterControl.valueChanges
      .pipe(
        debounceTime(500), // Waiting for 500ms while you're typing
        distinctUntilChanged() // Prevents the emitting if the 'start' value and the 'end' value are the same
      )
      .subscribe((value) => {
        this.ddService.filterGroups(value)
      });

    this.sortCategoryControl.valueChanges.subscribe((value) => {
      let category = value=='Project Name' ? 'project' : value == 'Screening Date' ? 'screening' : 'closing'
      this.ddService.sortByCategory(category)
    })
  }

  ngOnInit() {
    this.ddService.getChecklists("Underwriting", true)
    this.sortCategoryControl.setValue('Closing Date')
  }

  public changeView(view: DueDiligenceView){
    if(this.view == view){
      return
    }
    this.view = view
    if(view===DueDiligenceView.ALL){
      this.ddService.getChecklists("Underwriting")
    } else {
      this.ddService.getChecklists("Underwriting", true)
    }
  }

  ngOnDestroy(){
    this.filterSubscription.unsubscribe()
  }


  protected readonly DueDiligenceView = DueDiligenceView;
}
